/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Keys_FindInputs */

const en_wc_tut_keys_find = /** @type {(inputs: Wc_Tut_Keys_FindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find / replace (regular expressions supported)`)
};

/**
* | output |
* | --- |
* | "Find / replace (regular expressions supported)" |
*
* @param {Wc_Tut_Keys_FindInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_keys_find = /** @type {((inputs?: Wc_Tut_Keys_FindInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Keys_FindInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_keys_find(inputs)
});
export { wc_tut_keys_find as "wc.tut.keys.find" }